var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/BasePage/BasePageHead.js",
  _this = this;
import React from 'react';
import Helmet from '../Helmet';
import { StaticContext } from '../StaticContext';
var BasePageHead = function BasePageHead() {
  var _React$useContext = React.useContext(StaticContext),
    clientConfig = _React$useContext['client-config'],
    environment = _React$useContext.environment;
  // https://prod.smassets.com/assets/static/images/surveymonkey
  var assetsPath = clientConfig !== null && clientConfig !== void 0 && clientConfig.assetsHost && environment !== null && environment !== void 0 && environment.domain ? "https://".concat(clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.assetsHost, "/assets/static/images/").concat(environment === null || environment === void 0 ? void 0 : environment.domain) : '';
  return /*#__PURE__*/React.createElement(Helmet, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("title", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 7
    }
  }, "Welcome to SurveyMonkey!"), /*#__PURE__*/React.createElement("meta", {
    name: "keywords",
    content: "SurveyMonkey,online surveys,online survey,web surveys, web survey,market research,free,research,stats,statistics,polls,voting,analyze,tool,decisions,planning,strategy,Community,forms,formsite,workgroups,cgi,database",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: "Create and publish online surveys in minutes, and view results graphically and in real time. SurveyMonkey provides free online questionnaire and survey software.",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("meta", {
    charset: "utf-8",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("meta", {
    name: "msapplication-config",
    content: "none",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("meta", {
    name: "author",
    content: "SurveyMonkey",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    href: "".concat(assetsPath, "/apple-touch-icon-precomposed.png"),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    sizes: "57x57",
    href: "".concat(assetsPath, "/apple-touch-icon-57x57-precomposed.png"),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    sizes: "60x60",
    href: "".concat(assetsPath, "/apple-touch-icon-60x60-precomposed.png"),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    sizes: "72x72",
    href: "".concat(assetsPath, "/apple-touch-icon-72x72-precomposed.png"),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    sizes: "76x76",
    href: "".concat(assetsPath, "/apple-touch-icon-76x76-precomposed.png"),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    sizes: "114x114",
    href: "".concat(assetsPath, "/apple-touch-icon-114x114-precomposed.png"),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    sizes: "120x120",
    href: "".concat(assetsPath, "/apple-touch-icon-120x120-precomposed.png"),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    sizes: "144x144",
    href: "".concat(assetsPath, "/apple-touch-icon-144x144-precomposed.png"),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    sizes: "152x152",
    href: "".concat(assetsPath, "/apple-touch-icon-152x152-precomposed.png"),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    sizes: "180x180",
    href: "".concat(assetsPath, "/apple-touch-icon-180x180-precomposed.png"),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("link", {
    rel: "shortcut icon",
    href: "".concat(assetsPath, "/favicon.ico"),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 7
    }
  }));
};
BasePageHead.propTypes = {};
BasePageHead.defaultProps = {};
export default BasePageHead;
//# sourceMappingURL=BasePageHead.js.map